 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"about":"about","boards":"boards","code~projects":"code~projects","projects":"projects","code~settings":"code~settings","code":"code","settings":"settings","libs":"libs","serial-base":"serial-base","serial-nav-app":"serial-nav-app","servers":"servers"}[chunkId]||chunkId) + "." + {"about":"d060e157","boards":"274efc0a","chunk-2d21e957":"b6889311","code~projects":"d37a0056","projects":"c04b3a77","code~settings":"48ad09c2","code":"52406a5e","settings":"90af06e7","libs":"33b536e6","serial-base":"8b4b9922","serial-nav-app":"181b7ca8","servers":"ae4b539a","chunk-0b65ffb6":"b013156c","chunk-12950967":"d1b6b07c","chunk-2d0a3577":"6d7c8e42","chunk-2d0a43df":"edc4989f","chunk-2d0aa90c":"07c7ea69","chunk-2d0aab07":"4bc4e88a","chunk-2d0abc00":"1469fd22","chunk-2d0ae937":"3c41d683","chunk-2d0aeb45":"0ec15d50","chunk-2d0af08c":"01a6d3c6","chunk-2d0afa49":"b4e48d94","chunk-2d0b2762":"4a6f4bb1","chunk-2d0b6187":"00337985","chunk-2d0ba136":"12d1142c","chunk-2d0bb267":"77d06824","chunk-2d0bcec1":"86feb86e","chunk-2d0bdf38":"3ddb9e3f","chunk-2d0bff92":"55de1f52","chunk-2d0c0494":"5adc358b","chunk-2d0c0a09":"0c66081a","chunk-2d0c4313":"bf31e4d3","chunk-2d0c46d1":"6ac88c30","chunk-2d0c512b":"899f04c9","chunk-2d0cf16e":"ca888ecf","chunk-2d0d056d":"b0eb18bb","chunk-2d0d0645":"40459d42","chunk-2d0d2f22":"3ee31235","chunk-2d0d61fd":"a4ed14e0","chunk-2d0d7e63":"2ea8c91e","chunk-2d0e1b57":"71c91d9f","chunk-2d0e1fbe":"cbdee0aa","chunk-2d0e22d6":"a86c6457","chunk-2d0e542a":"02a326d7","chunk-2d0e57ec":"c147ec55","chunk-2d0e6553":"f5e48f57","chunk-2d0e6c86":"e50be0c0","chunk-2d0ea098":"ae6d826a","chunk-2d0f0a11":"631d5885","chunk-2d208ac5":"8cbdecb5","chunk-2d209408":"7f232250","chunk-2d20f745":"221e7d58","chunk-2d20ff23":"d9a0988d","chunk-2d2138c7":"24ea1d8b","chunk-2d216f3b":"fa4e018c","chunk-2d217e5b":"5bc6713d","chunk-2d21b84a":"ee0eb6f0","chunk-2d21dcd2":"cb55af11","chunk-2d21f327":"f28acdef","chunk-2d2214b3":"3a990375","chunk-2d221799":"9b6ea1f4","chunk-2d221814":"58381938","chunk-2d221a34":"87ff53be","chunk-2d22502a":"d00f7b1c","chunk-2d226775":"655c4b65","chunk-2d229411":"02f133ef","chunk-2d2295e9":"8eaff5ce","chunk-2d22c171":"d2dd748f","chunk-2d22c2b8":"5a2624eb","chunk-2d22ca58":"d5ac07ae","chunk-2d2311f7":"f859bdaf","chunk-2d237ee7":"80a733f8","chunk-2d238465":"197b0da9","chunk-7532b3ea":"52ca9e9b","chunk-e13e4362":"8cb669bc"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"code~projects":1,"code~settings":1,"code":1,"settings":1,"libs":1,"servers":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"about":"about","boards":"boards","code~projects":"code~projects","projects":"projects","code~settings":"code~settings","code":"code","settings":"settings","libs":"libs","serial-base":"serial-base","serial-nav-app":"serial-nav-app","servers":"servers"}[chunkId]||chunkId) + "." + {"about":"31d6cfe0","boards":"31d6cfe0","chunk-2d21e957":"31d6cfe0","code~projects":"14b054dc","projects":"31d6cfe0","code~settings":"ee67d9a5","code":"2791c0f7","settings":"9ffbe7c8","libs":"e06a8add","serial-base":"31d6cfe0","serial-nav-app":"31d6cfe0","servers":"9b013f4d","chunk-0b65ffb6":"31d6cfe0","chunk-12950967":"31d6cfe0","chunk-2d0a3577":"31d6cfe0","chunk-2d0a43df":"31d6cfe0","chunk-2d0aa90c":"31d6cfe0","chunk-2d0aab07":"31d6cfe0","chunk-2d0abc00":"31d6cfe0","chunk-2d0ae937":"31d6cfe0","chunk-2d0aeb45":"31d6cfe0","chunk-2d0af08c":"31d6cfe0","chunk-2d0afa49":"31d6cfe0","chunk-2d0b2762":"31d6cfe0","chunk-2d0b6187":"31d6cfe0","chunk-2d0ba136":"31d6cfe0","chunk-2d0bb267":"31d6cfe0","chunk-2d0bcec1":"31d6cfe0","chunk-2d0bdf38":"31d6cfe0","chunk-2d0bff92":"31d6cfe0","chunk-2d0c0494":"31d6cfe0","chunk-2d0c0a09":"31d6cfe0","chunk-2d0c4313":"31d6cfe0","chunk-2d0c46d1":"31d6cfe0","chunk-2d0c512b":"31d6cfe0","chunk-2d0cf16e":"31d6cfe0","chunk-2d0d056d":"31d6cfe0","chunk-2d0d0645":"31d6cfe0","chunk-2d0d2f22":"31d6cfe0","chunk-2d0d61fd":"31d6cfe0","chunk-2d0d7e63":"31d6cfe0","chunk-2d0e1b57":"31d6cfe0","chunk-2d0e1fbe":"31d6cfe0","chunk-2d0e22d6":"31d6cfe0","chunk-2d0e542a":"31d6cfe0","chunk-2d0e57ec":"31d6cfe0","chunk-2d0e6553":"31d6cfe0","chunk-2d0e6c86":"31d6cfe0","chunk-2d0ea098":"31d6cfe0","chunk-2d0f0a11":"31d6cfe0","chunk-2d208ac5":"31d6cfe0","chunk-2d209408":"31d6cfe0","chunk-2d20f745":"31d6cfe0","chunk-2d20ff23":"31d6cfe0","chunk-2d2138c7":"31d6cfe0","chunk-2d216f3b":"31d6cfe0","chunk-2d217e5b":"31d6cfe0","chunk-2d21b84a":"31d6cfe0","chunk-2d21dcd2":"31d6cfe0","chunk-2d21f327":"31d6cfe0","chunk-2d2214b3":"31d6cfe0","chunk-2d221799":"31d6cfe0","chunk-2d221814":"31d6cfe0","chunk-2d221a34":"31d6cfe0","chunk-2d22502a":"31d6cfe0","chunk-2d226775":"31d6cfe0","chunk-2d229411":"31d6cfe0","chunk-2d2295e9":"31d6cfe0","chunk-2d22c171":"31d6cfe0","chunk-2d22c2b8":"31d6cfe0","chunk-2d22ca58":"31d6cfe0","chunk-2d2311f7":"31d6cfe0","chunk-2d237ee7":"31d6cfe0","chunk-2d238465":"31d6cfe0","chunk-7532b3ea":"31d6cfe0","chunk-e13e4362":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([1,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
